import { z } from '@harvestiq/zod';

export const sendCustomSmsRequestBodySchema = z.object({
  message: z.string().max(1600),
  recipientIds: z.string().uuid().array().min(1),
});

export type SendCustomSmsRequestBody = z.infer<
  typeof sendCustomSmsRequestBodySchema
>;

export const sendCustomSmsResponseSchema = z.object({
  sent: z.number(),
  recipientTotal: z.number(),
});

export type SendCustomSmsResponse = z.output<
  typeof sendCustomSmsResponseSchema
>;
